import React from 'react';
import classNames from 'classnames';

import './HeaderTitle.scss';

export const HeaderTitle = ({ title, noPadding = false }) => {
  return (
    <div styleName={classNames('header-title', {
      'header-title--padding': !noPadding
    })}>{title}</div>
  );
};
